module.exports = __webpack_public_path__ + "static/maskot-0e0b3e3030de12a3237070d2e4f37a62.pdf";